import { render, staticRenderFns } from "./CompanyProfileStarter.vue?vue&type=template&id=0453e900&"
import script from "./CompanyProfileStarter.vue?vue&type=script&lang=js&"
export * from "./CompanyProfileStarter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports